var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.Featured)?_c('div',[_c('input',{staticClass:"form-control",attrs:{"type":"checkbox","checked":""},on:{"click":_vm.pressed}})]):_c('div',[_c('input',{staticClass:"form-control",attrs:{"type":"checkbox"},on:{"click":_vm.pressed}})])}
var staticRenderFns = []

export { render, staticRenderFns }